module.exports = __webpack_public_path__ + "img/形状.83097261.svg";